import { makeStyles } from '@material-ui/core'
import helpers from 'helpers'
import { useFormContext } from 'react-hook-form'

const styles = () =>
  makeStyles((theme) => {
    const { watch } = useFormContext()
    const fontFamily = watch('fontFamily') || 'Arial'

    const primaryColor = helpers.palette.validateColor(watch('primaryColor'))
    const secondaryColor = helpers.palette.validateColor(
      watch('secondaryColor'),
    )
    const calculatedSecondaryColor =
      helpers.palette.calculateColors(secondaryColor)
    const secondaryBGColor = helpers.palette.hexToRgba(secondaryColor, 0.06)

    return {
      dialogPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
      },
      title: {
        fontSize: 32,
        fontWeight: 600,
        fontFamily: fontFamily,
        color: helpers.palette.validateColor(primaryColor),
      },
      largeTitle: {
        fontSize: 28,
        fontWeight: 600,
      },
      subtitle: {
        fontSize: 14,
        fontFamily: fontFamily,
        color: helpers.palette.validateColor(primaryColor),
      },
      actionButton: {
        fontFamily: fontFamily,
        paddingBlock: 16,
        paddingInline: 6,
        fontWeight: 400,
      },
      menuButton: {
        borderRadius: 0,
        fontWeight: 400,
        padding: 16,
        textTransform: 'initial',
        justifyContent: 'flex-start',
        fontFamily: fontFamily,
        background: 'transparent',
        color: 'rgba(255, 255, 255, 0.85)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        transition:
          'background-color .15s ease, color .15s ease, border-color .15s ease',
      },
      menuButtonActive: {
        background: 'rgba(255, 255, 255, 0.18)',
        color: '#fff',
      },
      logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      },
      titleContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
      },
      dialogContent: {
        padding: 0,
      },
      dialogActions: {
        justifyContent: 'flex-end',
      },
      actionsBox: {
        display: 'flex',
        gap: 8,
        paddingInline: theme.spacing(3),
        paddingBlock: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
        },
      },

      rejectButton: {
        fontWeight: 400,
        flex: '1 1 220px',
        minWidth: 220,
        color: helpers.palette.validateColor(secondaryColor),
        '&:hover': {
          backgroundColor: helpers.palette.validateColor(secondaryBGColor),
        },
      },
      confirmButton: {
        fontWeight: 400,
        flex: '1 1 220px',
        minWidth: 220,
        color: helpers.palette.validateColor(secondaryColor),
        borderColor: helpers.palette.validateColor(
          calculatedSecondaryColor?.light,
        ),
        '&:hover': {
          borderColor: helpers.palette.validateColor(
            calculatedSecondaryColor?.dark,
          ),
          backgroundColor: helpers.palette.validateColor(secondaryBGColor),
        },
      },
      acceptButton: {
        fontWeight: 400,
        flex: '1 1 220px',
        minWidth: 220,
        backgroundColor: helpers.palette.validateColor(secondaryColor),
        color: helpers.palette.validateColor(
          calculatedSecondaryColor?.contrastText,
        ),
        '&:hover': {
          backgroundColor: helpers.palette.validateColor(
            calculatedSecondaryColor?.dark,
          ),
        },
      },
    }
  })

export default styles
